module.exports = __webpack_public_path__ + "static/img/03-03.5d374816.png";